export const Error = (): JSX.Element => {
  return (
    <h1>404 Not Found!</h1>
  )
}
